export const contact = {
  whatsappUrl:
    'https://wa.me/491745444423?text=Hallo%20Justus%2C%20ich%20interessiere%20mich%20f%C3%BCr%20ein%20Close%20CRM%20Setup.',
  whatsappDisplay: '+49 174 5444423',
  calendlyUrl:
    'https://calendly.com/justus-kraft/crm-automatisierung-demo-website?hide_gdpr_banner=1&primary_color=ff6b35&background_color=0a0e1a&text_color=ffffff',
  youtubeVideoId: 'HXlFRCbmWiM',
  siteUrl: 'https://close-crm-agentur-vergleich.de/',
}
